import { render, staticRenderFns } from "./TierProductDataTable.vue?vue&type=template&id=5766cc6f&scoped=true&"
import script from "./TierProductDataTable.vue?vue&type=script&lang=js&"
export * from "./TierProductDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TierProductDataTable.vue?vue&type=style&index=0&id=5766cc6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766cc6f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VCol,VContainer,VDataTable,VIcon,VPagination,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5766cc6f')) {
      api.createRecord('5766cc6f', component.options)
    } else {
      api.reload('5766cc6f', component.options)
    }
    module.hot.accept("./TierProductDataTable.vue?vue&type=template&id=5766cc6f&scoped=true&", function () {
      api.rerender('5766cc6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierProductDataTable.vue"
export default component.exports